import React from "react";
import t_1 from "../assets/images/t_1 (1).png";
import Typed from "react-typed";
import Description from "./Description";

const ToolsDetaile = () => {
  return (
    <div className="w-11/12 mx-auto">
      <div className="flex flex-col lg:flex-row md:flex-row">
        <div className="overflow-y-scroll relative lg:max-h-[800px] ">
          <img className="lg:max-w-[700px] p_img" src={t_1} alt="" />
        </div>
        <Description
          name={"Mr.tools"}
          d1={"Built a full-stack web app for tools manufacturers."}
          d2={
            " Fully responsive and Developed front-end user experience using React.js with admin panel."
          }
          d3={
            "There are two separate dashboard for User and admin implemented."
          }
          d4={
            "The main Feature of this web app is Payment system.It is implemented using spite."
          }
          d5={"Also authentication system were added with this site."}
          d6={
            "Technology:React.js,Tailwind.DaisyUi, Firebase, Node.js, Stripe, MongoDb"
          }
          live={"https://mrtools-bf4da.web.app/"}
          git={"https://github.com/Kibria934/Mr.tools"}
        />
      </div>
    </div>
  );
};

export default ToolsDetaile;
